/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Assignee = {
    properties: {
        employeeId: {
    type: 'number',
},
        employeeName: {
    type: 'string',
},
    },
};